import { render, staticRenderFns } from "./ProvinceIndexCategoryCreateOrUpdate.vue?vue&type=template&id=0b5d02b2&"
import script from "./ProvinceIndexCategoryCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./ProvinceIndexCategoryCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports